import { storage, storageR } from '../../../modules/firebase/core'
import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const CacheControl = `public,max-age=${60 * 60 * 24 * 14}`
const RoomStorageRef = storage.ref('TEST_ROOM')

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

const state = {}

const mutations = {}

const getters = {
  getSrc: state => key => {
    return state.items[key] ? state.items[key].url : null
  },
  getBackgroundUrl: state => key => {
    return state.items[key] ? `url(${state.items[key].url})` : null
  },
  tagged: state => tags => {
    return state.indexies.map(key => {
      return {
        key,
        ...state.items[key]
      }
    }).filter(image => {
      // return !tags[0] || image.tags.indexOf(tags[0]) > -1
      const isNoTarget = tags.some((tag) => {
        return image.tags.indexOf(tag) < 0
      })
      return !isNoTarget
    })
  }
}

const actions = {
  upload({ state }, { name, file, tags, owner }) {
    const path = `images/${uuidv4()}`
    return RoomStorageRef.child(path).put(file).then(snapshot => {
      const updateMetadataTask = snapshot.ref.updateMetadata({ cacheControl: CacheControl })
      const getDownloadURLTask = snapshot.ref.getDownloadURL()
      return Promise.all([getDownloadURLTask, updateMetadataTask])
    }).then(([url, metadata]) => {
      return state.$collection.add({
        name,
        contentType: metadata.contentType,
        size: metadata.size,
        url,
        owner,
        tags,
        timestamp: state.$timestamp()
      })
    })
  },
  async remove({ dispatch, getters }, key) {
    const image = getters['$get'](key)
    const ref = storage.refFromURL(image.url)
    await dispatch('$remove', key)
    return ref.delete()
  }
}

// function formatter({ name = '', contentType = null, size = 0, url = null, tags = [], timestamp = null }) {
//   return { name, contentType, size, url, tags, timestamp }
// }

function formatter(d) {
  return d
}

export default new FirestoreCollectionStore({
  $name: 'images',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})